import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "ViewPrioritiesModule"
const debug = false

export class ViewPrioritiesModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.VIEW_PRIORITIES, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                    = "Priorities"
        this.description             = ""
        this.svgIcon                 = "isvg-view-priorities"
        this.settingsMenuTopCategory = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel               = "Views"
        this.settingsUrl             = "settings/view-priorities"
        this.parentSection              = SettingsParentSection.VIEWS
    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}